import React from "react";
import { Pagination } from "@mui/material";

const BRAND_BLUE = "#00336C";
const BRAND_GREEN = "#648315";

export default function BrandPagination({ page, count, onChange, size = "medium" }) {
  return (
    <Pagination
      page={page}
      count={count}
      onChange={onChange}
      shape="rounded"
      size={size}
      sx={{
        "& .MuiPaginationItem-root": {
          color: BRAND_BLUE,
          fontWeight: 600,
          border: "none",
        },
        "& .MuiPaginationItem-root:hover": {
          backgroundColor: "rgba(0,51,108,0.07)",
        },
        "& .MuiPaginationItem-root.Mui-selected": {
          backgroundColor: BRAND_GREEN,
          color: "#ffffff",
          "&:hover": { backgroundColor: "#507011" },
        },
        "& .MuiPaginationItem-ellipsis": {
          color: BRAND_BLUE,
        },
        "& .MuiPaginationItem-icon": {
          color: BRAND_GREEN,
        },
      }}
    />
  );
}
